export default __webpack_public_path__ + "static/media/pagination-sizes.b0a70955.svg";